/* Launchpad: standard ecommerce dataLayer (GA4 schema). Wired to Horizon's ThemeEvents
   (cart:update, variant:selected, …) and to a Liquid-injected page payload
   (window.LaunchpadPageData). Vanilla, no dependencies. See docs/measurement.md.

   Events: view_item, view_item_list, select_item, add_to_cart, begin_checkout, search,
   sign_up. (purchase fires from the Web Pixel — checkout is sandboxed.) */
(function () {
  var cfg = window.LaunchpadConfig || {};
  if (!cfg.dataLayerEnabled) return;
  var dl = (window.dataLayer = window.dataLayer || []);

  function push(eventName, ecommerce) {
    dl.push({ ecommerce: null }); // clear the previous ecommerce object (GA4 best practice)
    dl.push({ event: eventName, ecommerce: ecommerce });
  }
  var money = function (cents) { return Math.round((Number(cents) || 0)) / 100; };

  // ---- Page-level: view_item / view_item_list (payload from lp-datalayer-page.liquid) ----
  var pd = window.LaunchpadPageData;
  if (pd && pd.event && pd.ecommerce) push(pd.event, pd.ecommerce);

  // ---- add_to_cart ----
  // Horizon dispatches BOTH adds and updates/removals under the same 'cart:update' event.
  // Only genuine product-form adds (PDP + quick-add) use source 'product-form-component'.
  // Cart-page/drawer edits & removals ('cart-items-component'), quick-order changes
  // ('quick-order-quantity'/'quick-order-remove-all'), and error events (didError) are NOT adds.
  document.addEventListener('cart:update', function (e) {
    var detail = e.detail || {};
    var d = detail.data || {};
    if (d.source !== 'product-form-component' || d.didError) return;

    var qty = Number(d.itemCount) || 1;
    var line = lineFromCart(detail.resource, d.productId);
    if (line) {
      pushAdd(line, qty, (detail.resource && detail.resource.currency) || cfg.shopCurrency);
      return;
    }
    // Success events carry the cart, but resolve it if the resource was empty.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var l = lineFromCart(cart, d.productId);
        if (l) pushAdd(l, qty, cart.currency || cfg.shopCurrency);
      })
      .catch(function () {});
  });

  // Pick the added product's line from a full cart object: match by productId (taking the most
  // recent matching line), falling back to the last line. Returns null without usable data.
  function lineFromCart(cart, productId) {
    if (!cart || !cart.items || !cart.items.length) return null;
    if (productId) {
      var matches = cart.items.filter(function (i) { return String(i.product_id) === String(productId); });
      if (matches.length) return matches[matches.length - 1];
    }
    return cart.items[cart.items.length - 1];
  }

  // GA4 add_to_cart for the quantity ADDED (d.itemCount), not the whole line total.
  function pushAdd(line, qty, currency) {
    var unit = money(line.final_price != null ? line.final_price : line.price);
    push('add_to_cart', {
      currency: currency,
      value: Math.round(unit * qty * 100) / 100,
      items: [{
        item_id: String(line.product_id != null ? line.product_id : ''),
        item_name: line.product_title || line.title,
        item_brand: line.vendor,
        item_variant: line.variant_title,
        price: unit,
        quantity: qty
      }]
    });
  }

  // ---- select_item — product cards expose data-lp-product (JSON GA4 item) ----
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-lp-product]');
    if (!card) return;
    try { push('select_item', { items: [JSON.parse(card.getAttribute('data-lp-product'))] }); } catch (x) {}
  });

  // ---- begin_checkout ----
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="checkout"], button[name="checkout"], a[href*="/checkout"], .shopify-payment-button button');
    if (t) push('begin_checkout', { currency: cfg.shopCurrency });
  });

  // ---- search ----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.matches('form[action$="/search"], form[action*="/search"]')) {
      var q = form.querySelector('input[name="q"]');
      if (q && q.value) push('search', { search_term: q.value });
    }
  }, true);

  // ---- sign_up (newsletter / customer create) ----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    if (form.querySelector('input[name="contact[email]"]') || form.getAttribute('action') === '/contact#newsletter') {
      dl.push({ event: 'sign_up', method: 'newsletter' });
    }
  }, true);
})();
